module.exports = __webpack_public_path__ + "img/bosspack-inactive.5e3ca6eb.svg";